import api from './client';

export interface ExpenseCategory {
  id: number;
  name: string;
  parent_id: number | null;
  code: string | null;
  sort_order: number;
  is_active: boolean;
  created_at: string;
}

export interface Expense {
  id: number;
  date: string;
  amount: number;
  category_id: number;
  legal_entity: string;
  payment_type: string;
  counterparty: string | null;
  basis: string | null;
  comment: string | null;
  created_by: number | null;
  created_at: string;
  updated_at: string;
  category?: ExpenseCategory;
}

export interface ExpenseSummary {
  total: number;
  by_category: { category: string; total: number }[];
}

export const expenseApi = {
  // Категории
  listCategories: () => api.get<ExpenseCategory[]>('/expenses/categories').then(r => r.data),
  createCategory: (data: Partial<ExpenseCategory>) => api.post<ExpenseCategory>('/expenses/categories', data).then(r => r.data),
  updateCategory: (id: number, data: Partial<ExpenseCategory>) => api.put<ExpenseCategory>(`/expenses/categories/${id}`, data).then(r => r.data),
  deleteCategory: (id: number) => api.delete(`/expenses/categories/${id}`),

  // Расходы
  list: (params?: Record<string, any>) => api.get<Expense[]>('/expenses', { params }).then(r => r.data),
  get: (id: number) => api.get<Expense>(`/expenses/${id}`).then(r => r.data),
  create: (data: Partial<Expense>) => api.post<Expense>('/expenses', data).then(r => r.data),
  update: (id: number, data: Partial<Expense>) => api.put<Expense>(`/expenses/${id}`, data).then(r => r.data),
  delete: (id: number) => api.delete(`/expenses/${id}`),
  summary: (params?: Record<string, any>) => api.get<ExpenseSummary>('/expenses/summary', { params }).then(r => r.data),
};
